var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand",on:{"click":_vm.routeToHome}},[_c('img',{attrs:{"src":require("../../../../assets/image/sony-logo.jpg"),"alt":"SONY"}}),_c('img',{attrs:{"src":require("../../../../assets/image/pss-logo.jpg"),"alt":"PSS"}})])}
var staticRenderFns = []

export { render, staticRenderFns }